export const mapTagFields = (tags) => {
  const tempList = tags?.slice(0, 2);
  const extraCount = tags?.length - tempList.length;

  return extraCount ? [...tempList, { id: 'extra-count', name: `+${extraCount}` }] : tempList;
};

export const getSlicedList = (list, count) => {
  const tempList = list?.slice(0, count);
  const extraCount = list?.length - tempList.length;

  return extraCount ? [...tempList, { id: 'extra-count', name: `+${extraCount}` }] : tempList;
};

export const getPageCount = (meta) => {
  if (!meta || !meta?.count || !meta?.limit) {
    return 1;
  }
  return Math.ceil(meta?.count / meta?.limit);
};

export const getCurrentPage = (meta) => {
  if (!meta || !meta?.offset) {
    return 1;
  }
  return Math.ceil(meta?.offset / meta?.limit) + 1;
};



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/helpers.js